import { can, type Rol } from '@leadsphere/types';

import { useAuth } from './useAuth.js';

const ROLES_VALIDOS: readonly string[] = ['root', 'head', 'analista', 'kam', 'ads_manager', 'gerente_comercial', 'comercial', 'digital', 'CEO'];

// Permisos sobre clientes compartidos entre ClienteDetalle.tsx y ClientesPage.tsx
// (SRS-01 §5.2) — un solo lugar para no duplicar la lógica de rol por vista.
export function useCanClient() {
  const { user } = useAuth();
  const rol = user?.rol && ROLES_VALIDOS.includes(user.rol) ? (user.rol as Rol) : null;

  return {
    canEditClient: rol !== null && can(rol, 'canEditClient'),
    canChangeStatus: rol !== null && can(rol, 'canChangeStatus'),
    canViewContacts: rol !== null && can(rol, 'canViewContacts'),
    // Escape hatch de PERMISOS para root (F.6 §1): root puede reactivar un
    // cliente 'fuera_del_servicio' seleccionando otro estatus — el backend
    // ya distingue este caso explícitamente (`rol !== 'root'` en
    // cambiarEstatus(), clientes.service.ts) y rechaza la transición para
    // cualquier otro rol, coincidiendo con este escape hatch de la UI.
    // Esto NO borra ni recupera datos — solo destraba el control en la UI.
    puedeReactivarFueraDeServicio: rol === 'root',
    // Prompt BJ-12 — botón "Copiar correos" en ClientesPage.tsx: literal
    // head/root (mismo estilo hardcodeado que puedeReactivarFueraDeServicio,
    // no una entrada nueva en permissions.ts). 'gerente_comercial' agregado
    // (decisión 15-oct), igual que el guard CORREOS_ACTIVOS del backend.
    canCopyEmails: rol === 'head' || rol === 'root' || rol === 'gerente_comercial',
  };
}
